import nlnAxios from "../../../api/nlnAxios";


//Create FAQs

const createFaqCategory = async (faqCategoryData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}
    const response = await nlnAxios.post("/library/faqs/categories", faqCategoryData);
    return response.data;
}

//Edit Resources
const editFaqCategory = async (faqCategoryData, token) => {

    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`
    // }

    const response = await nlnAxios.patch(`/library/faqs/categories/${faqCategoryData.faqCategoryId}`, faqCategoryData);
    return response.data
}

//Get FAQs

const getFaqCategory = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/public/faqs/categories");

    return response.data;
}

const deleteFaqCategory = async (faqCategoryId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/faqs/categories/" + faqCategoryId);

    return response.data;
}



const faqCategoryService = {
    createFaqCategory,
    editFaqCategory,
    getFaqCategory,
    deleteFaqCategory
}

export default faqCategoryService;